// ABOUTME: Return-profile picker — dropdown whose trigger and options show the carrier
// ABOUTME: logo, name and profile pill (stream-rule style), so shipper + type are visible.

import { Box, ButtonBase, useTheme } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";

import { tokens } from "../../theme";
import Text from "../theme/text/Text";
import { DropdownBase } from "../theme/dropdowns/Dropdown";
import ShipperProfileLabel from "./ShipperProfileLabel";

// Rich option row — the dropdown clones this with the profile as `option`.
const ProfileOption = ({ option }) => <ShipperProfileLabel profile={option} fullWidth />;

// Dropdown trigger — DropdownBase clones this with the selected id + option list.
const ProfileTrigger = ({ options, selected, onClick }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const profile = (options ?? []).find((p) => p.id === selected);

    return (
        <ButtonBase
            onClick={onClick}
            sx={{
                width: 1,
                height: 40,
                px: 0.5,
                borderRadius: 5,
                background: theme.palette.mode === "dark" ? colors.grey[400] : colors.bg["tertiary"],
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            {profile ? (
                <ShipperProfileLabel profile={profile} fullWidth />
            ) : (
                <Box sx={{ pl: 1.5 }}>
                    <Text bold>{t("choose")}</Text>
                </Box>
            )}
            <Box sx={{ display: "flex", alignItems: "center", transform: "rotate(90deg)", color: colors.txt["secondary"], flexShrink: 0 }}>
                <ChevronRightIcon />
            </Box>
        </ButtonBase>
    );
};

// props: returnProfiles (array), selected (id | -1), onChange(id)
const ReturnProfileSelector = (props) => {
    const { t } = useTranslation();

    return (
        <DropdownBase
            valueKey="id"
            displayName="name"
            options={props.returnProfiles ?? []}
            selected={props.selected}
            onChange={props.onChange}
            closeOnSelection
            defaultStyling
            shComponent={<ProfileOption />}
            searchOptions={{ enabled: true, placeholder: t("search") }}
        >
            <ProfileTrigger />
        </DropdownBase>
    );
};

export default ReturnProfileSelector;
